import React from "react";
import { Colors } from "../../Constants/colors";
import InputWrapper from "../input/inputWrapper";
import DropDownOptions, { DropdownOptions } from "../dropdownOptions";
import { FontFamily } from "../../Constants/Enums/FontFamily.enums";
import { FontSize } from "../../Constants/Enums/Size.enums";
import {
  ALIGN_ITEMS,
  DISPLAY,
  FLEX_DIRECTION,
  JUSTIFY_CONTENT,
} from "../../Constants/Enums/styles.enum";
import crossIcon from "./../../images/Cross.svg";
import { DropdownWrapper } from "./DropdownWrapper";

interface Props {
  wrapperClassName?: string;
  label: string;
  options: Array<DropdownOptions>;
  selectedOption: DropdownOptions | null;
  setSelectedOption: (value: DropdownOptions) => unknown;
  wrapperStlye?: React.CSSProperties;
  canBeEmpty?: boolean;
}

const Dropdown = ({
  label,
  wrapperClassName = "",
  selectedOption,
  options,
  setSelectedOption,
  wrapperStlye = {},
  canBeEmpty = false,
}: Props) => {
  // Refactor this
  const handleClearSelection = (e: any) => {
    e.stopPropagation();
    setSelectedOption({ value: null, text: "" });
  };

  return (
    <div style={{ ...wrapperStlye }}>
      <InputWrapper label={label}>
        <DropdownWrapper>
          {({ isDropdownClicked, setDropdownClicked }) => (
            <>
              {selectedOption?.text ? (
                <div
                  style={{
                    display: DISPLAY.FLEX,
                    flexDirection: FLEX_DIRECTION.ROW,
                    justifyContent: JUSTIFY_CONTENT.SPACE_BETWEEN,
                    alignItems: ALIGN_ITEMS.CENTER,
                  }}
                >
                  <p>{selectedOption?.text}</p>
                  {canBeEmpty ? (
                    <img
                      src={crossIcon}
                      style={{ width: "15px", height: "15px" }}
                      alt={"cross-con"}
                      onClick={handleClearSelection}
                    />
                  ) : (
                    <></>
                  )}
                </div>
              ) : (
                <div
                  style={{
                    color: Colors.LightGrey,
                    fontFamily: FontFamily.POPPINS_REGULAR,
                    fontSize: FontSize.F14,
                  }}
                >
                  Select
                </div>
              )}

              <DropDownOptions
                showDropdown={isDropdownClicked}
                onSelect={(value) => {
                  setSelectedOption(value);
                  setDropdownClicked(false);
                }}
                dropdownOption={options}
                selectedOption={selectedOption as DropdownOptions}
              />
            </>
          )}
        </DropdownWrapper>
      </InputWrapper>
    </div>
  );
};
export default Dropdown;
